import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import MapApp from './MapApp.jsx';

const inner_distributor_container = document.getElementById('distributor-map-container');

function App() {

    return (
        <MapApp />
    );
}

if (inner_distributor_container) {
    document.body.classList.add('react-distributor');
    ReactDOM.render(<App />, inner_distributor_container);
}
